export const routes = [
  {
    name: "guide",
    icon: "fas fa-book",
    pages: [
      { name: "installation", label: null },
      { name: "installation-with-cli", label: "new" },
      { name: "license", label: null },
      { name: "what-is-tailwind-css", label: null },
    ],
  },
  {
    name: "migration",
    icon: "fas fa-rocket",
    pages: [{ name: "2.x-migration-guide", label: null }],
  },
  {
    name: "Customization",
    icon: "fas fa-paint-brush",
    pages: [
      { name: "theming", label: null },
      { name: "colors", label: null },
      { name: "fonts", label: null },
      { name: "shadows", label: null },
      { name: "screens", label: null },
    ],
  },
  {
    name: "components",
    icon: "fas fa-shapes",
    pages: [
      {
        name: "accordion",
        label: null,
      },
      {
        name: "alert",
        label: null,
      },
      {
        name: "avatar",
        label: null,
      },
      {
        name: "badge",
        label: null,
      },
      {
        name: "breadcrumbs",
        label: null,
      },
      {
        name: "button",
        label: null,
      },
      {
        name: "button-group",
        label: null,
      },
      {
        name: "card",
        label: null,
      },
      {
        name: "checkbox",
        label: null,
      },
      {
        name: "chip",
        label: null,
      },
      {
        name: "collapse",
        label: null,
      },
      {
        name: "carousel",
        label: null,
      },
      {
        name: "dialog",
        label: null,
      },
      {
        name: "drawer",
        label: null,
      },
      {
        name: "icon-button",
        label: null,
      },
      {
        name: "input",
        label: "updated",
      },
      {
        name: "form",
        label: null,
      },
      {
        name: "list",
        label: null,
      },
      {
        name: "menu",
        label: null,
      },
      {
        name: "navbar",
        label: null,
      },
      {
        name: "popover",
        label: null,
      },
      {
        name: "progress-bar",
        label: null,
      },
      {
        name: "pagination",
        label: null,
      },
      {
        name: "radio-button",
        label: null,
      },
      {
        name: "rating-bar",
        label: null,
      },
      {
        name: "select",
        label: null,
      },
      {
        name: "slider",
        label: null,
      },
      {
        name: "speed-dial",
        label: null,
      },
      {
        name: "spinner",
        label: null,
      },
      {
        name: "stepper",
        label: null,
      },
      {
        name: "switch",
        label: null,
      },
      {
        name: "tabs",
        label: null,
      },
      {
        name: "textarea",
        label: null,
      },
      {
        name: "timeline",
        label: null,
      },
      {
        name: "tooltip",
        label: null,
      },
      {
        name: "typography",
        label: null,
      },
      {
        name: "footer",
        label: null,
      },
      {
        name: "img",
        label: null,
      },
      {
        name: "video",
        label: null,
      },
      {
        name: "sidebar",
        label: null,
      },
      {
        name: "table",
        label: null,
      },
    ],
  },
];
